// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__CNupJ","range":"MonthRangeSwitch_range__3kjMV","disabled":"MonthRangeSwitch_disabled__19VBd"};